module.exports = __webpack_public_path__ + "assets/img/InterfaceBuilder.bc29ff2e.svg";